<script>
  import { Link } from 'svelte-navigator'

  export let title, link = false, hover = false, color = "white"
</script>

<div class="container bg-color-{color}" class:hover={ hover || link }>
  {#if link}
    <Link to={link}>{ title }</Link>
  {:else}
    { title }
  {/if}
</div>

<style lang="scss">
  .container {
    &, a {
      @include typo-grotesk-text-18;
    }
    @include box-shadow;
    &.hover:hover {
      box-shadow: $link-hover-shadow;
    }
    display: inline;

    @each $name, $color in $card-bg-colors {
      &.bg-color-#{$name} {
        background-color: $color
      }
    }

    position: relative;
    top: 2px;
    padding: 7px 15px 3px;
    height: 34px;
    border-radius: 20px;
  }

</style>